"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "11",
    height: "12",
    viewBox: "0 0 11 12"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M4.57949791,2.21211756 C2.05962343,2.21211756 1.6032568e-16,4.39474922 0,7.09238386 C-1.6032568e-16,9.7900185 2.05962343,11.9603882 4.57949791,11.9603882 C7.09937238,11.9603882 9.09729004,10.6610135 9.09729004,7.96337891 L7.03955078,7.96337891 C7.03955078,9.49612586 6.0292887,9.87585233 4.57949791,9.87585233 C3.12970711,9.87585233 1.95606695,8.62513081 1.95606695,7.08012188 C1.95606695,5.53511296 3.12970711,4.49930994 4.57949791,4.49930994 L7.03955081,4.50994497 L7.03955078,6.60559082 L11,3.25438549 L7.03955078,0 L7.03955078,2.25172944 L4.57949791,2.21211756 Z"
  }));
};

exports["default"] = _default;